import { CourseData } from "@vixi/types";
import { STEP_TYPE } from "@vixi/types";

const stepTitle = {
  [STEP_TYPE.CONVERSATION]: "Course.Conversation",
  [STEP_TYPE.MCQ]: "Course.Question",
  [STEP_TYPE.FITB]: "Course.Question",
  [STEP_TYPE.MATCHING]: "Course.Question",
};

export function getStepTitle(step: CourseData.Step): string {
  return step.title ?? stepTitle[step.type];
}

export default getStepTitle;
